import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItemIcon, MenuItem, Slide, TextField, Typography } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RenameWatchlist = ({ selectedWatchlist, selectedWatchlistDesc, handleRenameWatchlist, isSystemDefault }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [name, setName] = useState(selectedWatchlist);
  const [description, setDescription] = React.useState(selectedWatchlistDesc);
  const [labelText, setLabelText] = React.useState('New watchlist name');
  const [labelDescText, setLabelDescText] = React.useState('Description');

  const handleRenameDialog = () => { setOpenDialog(true); };

  const handleDialogClose = () => { setOpenDialog(false); };

  const handleInputChange = (event) => {
    const input = event.target.value;
    if (input.length > 0 && input[0] === ' ') {
      setLabelText('Text should not start with a space');
    } else if (/.*/.test(input)) { // Match any character
      setLabelText('New watchlist name');
      setName(input);
    } else {
      setLabelText('Invalid Input');
    }
  };

  const handleDescChange = (event) => {
    const input = event.target.value;
    if (input.length > 0 && input.trim() === ' ') {
      setLabelDescText('Space cannot be the first character');
    } else if (/.*/.test(input)) {
      setDescription(input);
      setLabelDescText('Description');
    } else {
      setLabelDescText('Special characters are not allowed');
    }
  };

  return (
    <>
      <MenuItem onClick={handleRenameDialog} disabled={isSystemDefault}>
        <ListItemIcon>
          <EditRoundedIcon fontSize="small" />
        </ListItemIcon>
        <Typography variant="inherit" noWrap fontSize="small" wrap>
          Rename
        </Typography>
      </MenuItem>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="xs"
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="rename-dialog"
        onSubmit={(e) => { e.preventDefault(); handleRenameWatchlist(selectedWatchlist, name, description) }}
      >
        <DialogTitle sx={{ pb: '10px !important' }}>{`Rename "${selectedWatchlist}"`}</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { mt: 0, width: { md: '44ch', xs: '100%', sm: '100%' } },
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              size="small"
              required
              autoFocus
              margin="dense"
              id="name"
              helperText=""
              label={labelText}
              type="text"
              error={labelText !== 'New watchlist name'}
              fullWidth
              variant="standard"
              value={name}
              onChange={(event) => handleInputChange(event)}
              inputProps={{ maxLength: 30 }} // Limit the input to 30 characters
              sx={{ my: 2 }}
            />
            <TextField
              size="small"
              margin="dense"
              id="desc"
              helperText=""
              label={labelDescText}
              type="text"
              fullWidth
              error={labelDescText !== 'Description'}
              variant="standard"
              value={description}
              onChange={(event) => handleDescChange(event)}
              inputProps={{ maxLength: 100 }} // Limit the input to 30 characters
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 1, pt: 0 }}>
          <Button sx={{ textTransform: 'none', mr: 2 }} onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" sx={{ textTransform: 'none', mr: 2 }}
            onClick={() => handleRenameWatchlist(selectedWatchlist, name, description)}
            disabled={name === "" || labelText !== 'New watchlist name'}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>);
}
export default (RenameWatchlist)
